var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-spinner"},[_vm._m(0),(_vm.message)?_c('h6',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-box"},[_c('div',{staticClass:"spinner"})])
}]

export { render, staticRenderFns }